export default __webpack_public_path__ + "static/media/clipboard.a7baf410.svg";